import Alpine from 'alpinejs';
import { isAppointmentForm } from "./helpers";
import { AutocompleteResult } from "./types";
import { LocalStorageAutocompleteItem } from "../../scripts/forms/quotation-form/types";
import {
    Localisation,
    UserData
} from '../../types/user'
import { ApiShop, TrybaShop } from '../../types/shop'
import { City, storeLocatorAutocomplete, storeLocatorGeolocation } from '../../scripts/helpers/storeLocator';
import {
    getUserData,
    removeUserShop,
    setUserDataLocalisation,
    setUserDataShop
} from '../../helpers/user'
import { AlpineComponentTryba } from '../../scripts/alpine/include/global';

const hasValidStoreCode = (store: any): boolean => {
    return !!(store && typeof store === 'object' && typeof store.code === 'string' && store.code.length > 0);
};

document.addEventListener('alpine:init', () => {
    Alpine.data('initAutocomplete', (): AlpineComponentTryba => {
        return {
            results: [],
            inputElement: document.querySelector('.inputElement'),
            nbInputs: null,
            contentInput: null,
            displayResultsWording: false,
            overlayPage: false,
            noResults: false,
            tooShort: false,
            tooLong: false,
            eraseResultsSelector: false,
            selectedItem: null,
            modal: false,
            geolocResults: [],
            data: [],
            lat: null,
            lng: null,
            zipCode: null,
            city: null,
            loading: false,
            preSelected: null,
            api_url: window.location.origin + '/api/shop/',
            selectedElementSideTabABTEST: null,
            sideTabCard: null,
            sideTabCardStatic: null,
            shopUrl: null,
            showUnavailableStoreMessage: false,
            init() {
                // Bind to THIS autocomplete instance's own input. Several autocompletes can
                // coexist on the page (e.g. the AB test CP field in the coordinates step alongside
                // the location step), so a global `.inputElement` lookup would target the wrong one.
                this.inputElement = (this.$el?.querySelector('.inputElement') as HTMLInputElement | null)
                    ?? document.querySelector('.inputElement');

                //Prevent submit by "enter" clicking
                function checkEnter(e) {
                    e = e || event;
                    const txtArea = /textarea/i.test((e.target || e.srcElement).tagName);
                    return txtArea || (e.keyCode || e.which || e.charCode || 0) !== 13;
                }
                if (this.myStep) {
                    this.$refs.myStep.onkeyup = checkEnter;
                }

                //Fill input geoloc if in local storage
                if (this.form && this.form.action == '/api/forms/quotation/') {
                    this.initInputContent = getUserData();
                    if (this.initInputContent) {
                        setTimeout(() => {
                            this.inputElement = (this.$el?.querySelector('.inputElement') as HTMLInputElement | null)
                                ?? document.querySelector('.inputElement');
                            try {
                                this.fillFromLocal(this.initInputContent);
                            } catch (e) {
                                console.warn('fillFromLocal not available');
                            }
                        }, 200);
                    }
                }
                const userData = getUserData();
                window.addEventListener('DOMContentLoaded', () => {
                    if (document.body.dataset.type == 'homepage' && userData && userData.localisation) {
                        const input = this.$refs.autocompleteInput as HTMLInputElement | null;
                        if (input) {
                            input.value = userData.localisation.city;
                        }
                    }
                });
            },
            //Make api call with inputs and check if there are errors
            validateInput(event: any, type: any) {
                const targetValue = event.target.value.trim();
                if (event.keyCode == 27) {
                    this.closeModal();
                    return;
                }
                if (type) {
                    console.log(type);
                }
                if (targetValue == '') {
                    this.disabled = true;
                    if (this.buttonsDisabled?.projectLocalisation !== undefined) {
                        this.buttonsDisabled.projectLocalisation = true;
                    }
                }
                if (targetValue !== '' && event.keyCode !== 13) {
                    this.nbInputs = targetValue.length;
                    this.modal = true;
                    if (!isNaN(targetValue)) {
                        if (this.nbInputs == 0) {
                            this.disabled = true;
                            if (this.buttonsDisabled?.projectLocalisation !== undefined) {
                                this.buttonsDisabled.projectLocalisation = true;
                            }
                        }
                        if (this.nbInputs > 5) {
                            this.noResults = false;
                            this.tooLong = true;
                            return;
                        }
                    }
                    storeLocatorAutocomplete(targetValue.replace(/-/g, ' '), isAppointmentForm(event.target) ? true : false)
                        .then((cities) => {
                            (this.results as Array<City>) = cities;
                        })
                        .then(() => {
                            this.overlayPage = true;
                            this.displayResults();
                        })
                        .catch((error) => {
                            console.error('Error fetching autocomplete results:', error);
                            this.results = [];
                            this.displayResults();
                        });
                }
            },
            selectedViaEnter(event, type: string) {
                if (this.results && this.results.length > 0) {
                    this.selectedItem = this.results[0];
                    this.selectedElement(this.selectedItem);

                    if (type == 'home') {
                        event.cancelBubble = true;
                        event.returnValue = false;
                        if (event.stopPropagation) {
                            event.stopPropagation();
                            event.preventDefault();
                        }
                        window.location.href = 'devis-en-ligne/?cp=' + this.selectedItem.codePostaux[0];
                    } else if (type == 'devis') {
                        this.closeModal();

                        const target = JSON.parse(JSON.stringify(this.selectedItem));
                        this.fillInput(target);
                        event.target.value = `${target.cp} ${target.ville}`;
                        this.refreshStoreCard();
                    } else {
                        event.cancelBubble = true;
                        event.returnValue = false;
                        if (event.stopPropagation) {
                            event.stopPropagation();
                            event.preventDefault();
                        }
                        window.location.href = `?shop=${this.selectedItem.magasin.code}`;
                    }
                } else {
                    event.cancelBubble = true;
                    event.returnValue = false;
                    if (event.stopPropagation) {
                        event.stopPropagation();
                        event.preventDefault();
                    }
                }
            },
            getSelectedStore(item: AutocompleteResult, index: number|null|undefined = null) {
                if (index !== null && index !== undefined && item.magasin_par_code_postal) {
                    const postalCode = (item as any).codesPostaux?.[index];
                    if (postalCode && hasValidStoreCode(item.magasin_par_code_postal[postalCode])) {
                        return item.magasin_par_code_postal[postalCode];
                    }
                }

                if (hasValidStoreCode(item.magasin)) {
                    return item.magasin;
                }

                return null;
            },
            fillSideTabCard(item: AutocompleteResult, index: number|null|undefined = null) {
                this.shopUrl = null;
                this.sideTabCard = null;
                this.preSelected = null;
                this.showUnavailableStoreMessage = false;

                const selectedStore = this.getSelectedStore(item, index);
                if (selectedStore) {
                    this.shopUrl = selectedStore.url;
                    if (this.shopUrl === null || this.shopUrl === undefined) {
                        this.shopUrl = `${window.location.origin}/espace-conseil/?shop=${selectedStore.code}`;
                    }
                    fetch(`${this.api_url}${selectedStore.code}/`)
                        .then(async (response: Response) => {
                            try {
                                const pdvDatas = (await response.json()) as ApiShop;
                                this.sideTabCard = pdvDatas;
                            } catch (e) {
                                if (e instanceof SyntaxError) {
                                    console.error('Retour serveur non conforme JSON');
                                } else {
                                    console.error(e);
                                }
                            }
                        })
                        .catch(() => {
                            // noop
                        });
                    return;
                }

                this.sideTabCardStatic = null;
                removeUserShop();
                this.showUnavailableStoreMessage = true;

                if (item.departement?.code) {
                    this.shopUrl = `${window.location.origin}/espace-conseil/${item.departement?.code}/?no_pdv`;
                }
            },
            emptyPreselect() {
                this.preSelected = null;
                this.sideTabCard = null;
                this.sideTabCardStatic = null;
                this.showUnavailableStoreMessage = false;
            },
            preSelectedFct(item, staticElement: boolean, index: number|null|undefined) {
                if (staticElement) {
                    this.showUnavailableStoreMessage = false;
                    const input = item.querySelector('input');
                    input.checked = true;

                    item = JSON.parse(item.dataset.item);
                    // Update with refactor of user data
                    const goodValueFormat = {
                        localisation: {
                            city: item.city,
                            zip: item.zip,
                        },
                        shop: {
                            address: item.address,
                            city: item.city,
                            clientNumber: item.clientNumber,
                            name: item.name,
                            phone: item.phones[0],
                            zip: item.zip,
                        },
                        codesPostaux: [[item.zip]],
                    }
                    this.sideTabCardStatic = goodValueFormat;
                    item = goodValueFormat;

                    this.preSelected = item;
                } else {
                    const selectedStore = this.getSelectedStore(item, index);
                    if (!selectedStore) {
                        this.preSelected = null;
                        this.sideTabCardStatic = null;
                        this.showUnavailableStoreMessage = true;
                        removeUserShop();
                        return;
                    }

                    this.showUnavailableStoreMessage = false;

                    const storeZip = selectedStore.code_postal || selectedStore.cp || '';
                    const storeCity = selectedStore.ville || selectedStore.prettyCity || '';
                    const storeAddress = selectedStore.adresse || '';
                    const storeName = selectedStore.nom || '';

                    setUserDataShop(
                        selectedStore.telephone,
                        storeZip,
                        storeCity,
                        storeAddress,
                        storeName,
                        selectedStore.code,
                        selectedStore.url ? selectedStore.url :  `${window.location.origin}/espace-conseil/?shop=${selectedStore.code}`,
                        selectedStore.latitude || '',
                        selectedStore.longitude || '',
                    )
                    if (index !== null && index !== undefined) {
                        setUserDataLocalisation({ zip: item.codesPostaux[index], city: item.nom} as Localisation);
                        (this.$refs.sideTabInput as HTMLInputElement).value = (item.codesPostaux[index] + ' ' + item.nom).trim();
                    }

                    this.preSelected = item;
                }
            },
            setShopChoiceSideTab() {
                if (this.sideTabCard) {
                    this.displayPdvDatas(this.sideTabCard);
                } else if (this.sideTabCardStatic) {
                    this.displayPdvDatas(this.sideTabCardStatic);
                    window.localStorage.setItem('user_data', JSON.stringify(this.sideTabCardStatic));
                } else {
                    return;
                }

                this.changeShop = false;
                this.handleDatasFromStorage();
            },
            //Store in localStorage result selected
            selectedElement(item: AutocompleteResult, index = 0, subCp = '') {
                //Store gps position
                this.selectedItem = item;

                setUserDataLocalisation({
                    zip: this.selectedItem.codesPostaux[index],
                    city: this.selectedItem.nom,
                } as Localisation);

                let associatedShop = this.selectedItem.magasin;

                if ('' !== subCp && this.selectedItem.magasin_par_code_postal && this.selectedItem.magasin_par_code_postal[subCp]) {
                    associatedShop = this.selectedItem.magasin_par_code_postal[subCp];
                }

                if (item.magasin == null) {
                    removeUserShop();
                    return;
                }

                setUserDataShop(associatedShop.telephone, associatedShop.code_postal, associatedShop.ville, associatedShop.adresse, associatedShop.nom, associatedShop.code, associatedShop.url ? associatedShop.url : `${window.location.origin}/espace-conseil/?shop=${associatedShop.code}`, associatedShop.latitude, associatedShop.longitude);
            },
            //Display list of results
            displayResults() {
                this.results = JSON.parse(JSON.stringify(this.results));
                this.overlayPage = true;
                this.modal = true;

                if (this.results.length) {
                    this.tooLong = false;
                    this.tooShort = false;
                    this.noResults = false;
                    this.displayResultsWording = true;
                    this.eraseResultsSelector = true;
                } else {
                    //No results
                    if (this.nbInputs >= 1) {
                        this.noResults = true;
                        this.tooShort = false;
                        this.tooLong = false;
                        this.eraseResultsSelector = true;
                    }
                    if (!isNaN(this.contentInput)) {
                        if (this.nbInputs > 5) {
                            this.noResults = false;
                            this.tooLong = true;
                        }
                    }

                    if (this.nbInputs < 1) {
                        this.overlayPage = false;
                    }
                    this.displayResultsWording = false;
                }
            },
            //Open modal
            openModal() {
                this.modal = true;
                this.displayResults();
            },
            //Close modal on click outside
            closeModal() {
                this.modal = false;
            },
            //Erase input
            eraseResults() {
                this.contentInput = null;
                this.tooLong = false;
                this.tooShort = false;
                this.noResults = false;
                this.displayResultsWording = false;
                this.overlayPage = false;
                this.eraseResultsSelector = false;
                this.nbInputs = null;
                this.results = [];
                if (this.inputElement) {
                    this.inputElement.value = '';
                    this.inputElement.setAttribute('value', '');
                }
            },
            //Scroll to listing of departements bottom of page
            scrollToRealAnchor(anchor: string, offset = 0): void {
                if (anchor) {
                    // history.pushState(null,'',`#${anchor}`);
                    anchor = anchor.replace('#', '');
                    const target = document.getElementById(anchor);
                    const header = document.querySelector('header');
                    let headerHeight = 0;
                    if (header) {
                        headerHeight = header.getBoundingClientRect().height;
                    }

                    let offsetTop;
                    if (target) {
                        offsetTop = target.getBoundingClientRect().top + window.scrollY - offset - headerHeight;
                    }
                    scroll({
                        top: offsetTop,
                        behavior: 'smooth',
                    });
                }
            },
            scrollToAnchor(offset = 0) {
                this.overlayPage = false;
                this.tooLong = false;
                this.tooShort = false;
                this.noResults = false;
                this.modal = false;

                const target = document.getElementById('listing_departments');
                let offsetTop;
                if (target) {
                    offsetTop = target.getBoundingClientRect().top + window.scrollY - offset;
                }
                scroll({
                    top: offsetTop,
                    behavior: 'smooth',
                });
            },
            ////////////////////
            //Geoloc
            ////////////////////
            geolocMe() {
                this.geolocLoading = true;
                this.eraseResults();
                this.loading = true;
                this.launchGeoloc();
            },
            async launchGeoloc() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(async (position) => {
                        if (position) {
                            const lat = position.coords.latitude;
                            const lng = position.coords.longitude;

                            storeLocatorGeolocation(lat, lng)
                                .then((cities) => {
                                    (this.geolocResults as Array<City>) = cities;
                                })
                                .then(() => {
                                    this.geolocLoading = false;
                                    this.loading = false;

                                    this.getLocation(this.geolocResults);
                                })
                                .catch((error) => {
                                    console.error('Error fetching autocomplete results:', error);
                                    throw new Error(error.statusText);
                                });
                        }
                    });
                }
            },
            localStorageStore() {
                this.initInputContent = getUserData();
                this.fillFromLocal(Alpine.raw(this.initInputContent));
            },
            getLocation(data: City[]) {
                if (!data.length) {
                    alert('Votre position est introuvable');
                    return;
                }
                data.forEach((result) => {
                    this.zipCode = result.codesPostaux[0];
                    this.city = result.nom;
                });

                this.searchFromGeoloc();
            },
            searchFromGeoloc() {
                storeLocatorAutocomplete(this.zipCode)
                    .then((cities) => {
                        (this.results as Array<City>) = cities;
                    })
                    .then(() => {
                        this.loading = false;
                        if (this.inputElement) {
                            if (this.city) {
                                this.contentInput = this.city;
                                this.inputElement.setAttribute('value', this.city);
                                this.nbInputs = this.contentInput.length;
                            }
                        }
                        this.displayResults();
                    })
                    .catch((error) => {
                        console.error('Error fetching autocomplete results:', error);
                    });
            },
            fillFromLocal(item: UserData | null): void {
                if (!item) {
                    console.log('item from local storage is undefined');
                    return;
                }
                //GPS position in local storage
                try {
                    if (item.localisation) {
                        const { zip, city } = item.localisation;
                        this.zipcode = zip;
                        this.city = city;
                        if (this.inputElement) {
                            this.inputElement.value = (zip + ' ' + city).trim();
                        }
                        if (item.shop) {
                            this.displayUserDataShopCard(item.shop);
                        }
                        this.disabled = false;
                        if (this.buttonsDisabled?.projectLocalisation !== undefined) {
                            this.buttonsDisabled.projectLocalisation = false;
                        }
                    }
                } catch (e) {
                    console.warn(e);
                }
            },
            fillInput(item: any, index = 0) {
                this.zipcode = item.codesPostaux[index];
                this.city = item.nom;

                this.inputElement.value = (this.zipcode + ' ' + this.city).trim();
                //Allow go next step
                this.disabled = false;
                if (this.buttonsDisabled?.projectLocalisation !== undefined) {
                    this.buttonsDisabled.projectLocalisation = false;
                }
                // AB test "Skip CP step" : le champ location du coordinatesStep ne déclenche pas de keyup/blur ici, on revalide explicitement
                if (typeof this.validateLastStep === 'function') {
                    this.validateLastStep('location');
                }
                this.displayStoreCard(item);
            },
            fillInputPrev(item: any, index = 0) {
                this.step = this.steps['location'];
                //Get nextStep key
                this.nextStepKey = this.step.fieldsNextStep;
                //Delete in prevSteps, arrayChoice and dataChoice all infos after actual step
                const targetName = this.step.name;
                const targetIndex = this.prevSteps.findIndex((obj) => obj.name === targetName);
                if (targetIndex !== -1) {
                    this.prevSteps.splice(targetIndex + 1);
                }

                let foundArrayChoice = false;
                for (const key in this.arrayChoice) {
                    if (foundArrayChoice) {
                        delete this.arrayChoice[key];
                    }
                    if (key === targetName) {
                        foundArrayChoice = true;
                    }
                }

                let foundDataChoice = false;
                for (const key in this.dataChoice) {
                    if (foundDataChoice) {
                        delete this.dataChoice[key];
                    }
                    if (key === targetName) {
                        foundDataChoice = true;
                    }
                }

                this.zipcode = item.codesPostaux[index];
                this.city = item.nom;
                this.inputElement.value = (this.zipcode + ' ' + this.city).trim();
                //Allow go next step
                this.disabled = false;
                if (this.buttonsDisabled?.projectLocalisation !== undefined) {
                    this.buttonsDisabled.projectLocalisation = false;
                }
                this.displayStoreCard(item);

                //Go next step
                setTimeout(() => {
                    this.dataChoice[this.step.name] = this.inputElement.value;
                    this.arrayChoice[this.step.name] = this.inputElement.value;
                    this.nextStep(targetIndex);
                }, 200);
            },
            displayStoreCard(item: AutocompleteResult | LocalStorageAutocompleteItem[]) {
                if (this.form && this.$store.global.isMobile) {
                    this.enableStoreCard = false;
                } else {
                    if ('magasin' in item) {
                        if (Array.isArray(item.magasin) && item.magasin.length === 0) {
                            this.enableStoreCard = false;
                        } else {
                            this.enableStoreCard = true;
                            this.displayStoreCardFromAutocomplete(item);
                        }
                    } else {
                        this.enableStoreCard = Array.from(item)
                            .map((i) => Object.keys(i))
                            .flat()
                            .some((i) => i === 'shop_city' || i === 'shop_code');
                        this.displayStoreCardFromLocalStorage(item);
                    }

                    this.refreshStoreCard();
                }
            },
            displayUserDataShopCard(shop: TrybaShop) {
                if (this.form && this.$store.global.isMobile) {
                    this.enableStoreCard = false;
                } else {
                    this.enableStoreCard = true;
                    this.displayStoreCardFromUserData(shop);
                    this.refreshStoreCard();
                }
            },
            refreshStoreCard() {
                let latlng = '';
                let center = '';
                let marker = '';
                let address = this.shopAdresse + this.shopCity + this.shopCP;
                if (this.shopLatitude && this.shopLongitude) {
                    latlng = this.shopLatitude + ',' + this.shopLongitude;
                    address = '';
                    center = '&center=' + latlng;
                    marker = latlng;
                }
                this.storeMap = `https://maps.googleapis.com/maps/api/staticmap?&size=200x200${center}&zoom=15&markers=anchor:32,10%7C%7C${marker}%7C${address}&key=AIzaSyCKxNknMNNfb_gcBFrAKTQZCCdtKvNO18M&style=feature:poi.business|visibility:off&style=feature:poi.sports_complex|visibility:off`;
            },
            displayStoreCardFromUserData(shop: TrybaShop) {
                this.storeDatas = shop;
                this.shopAdresse = shop.address;
                this.shopTelephone = shop.phone;
                this.shopCity = shop.city;
                this.shopCP = shop.zip;
                this.shopName = shop.name;
                this.shopLatitude = shop.latitude;
                this.shopLongitude = shop.longitude;
            },
            displayStoreCardFromAutocomplete(item: AutocompleteResult) {
                if (item.magasin) {
                    this.storeDatas = item.magasin;
                    this.shopAdresse = this.storeDatas.adresse;
                    this.shopTelephone = this.storeDatas.telephone;
                    this.shopCity = this.storeDatas.prettyCity;
                    this.shopCP = this.storeDatas.cp;
                    this.shopName = this.storeDatas.nom;
                    this.shopLatitude = this.storeDatas.latitude;
                    this.shopLongitude = this.storeDatas.longitude;
                }
            },
            displayStoreCardFromLocalStorage(item: LocalStorageAutocompleteItem[]) {
                this.storeDatas = item;
                this.storeDatas.forEach((data: LocalStorageAutocompleteItem) => {
                    if (data.adresse) {
                        this.shopAdresse = data.adresse;
                    }
                    if (data.shop_city) {
                        this.shopCity = data.shop_city;
                    }
                    if (data.postal_code) {
                        this.shopCP = data.postal_code;
                    }
                    if (data.nom) {
                        this.shopName = data.nom;
                    }
                    if (data.latitude) {
                        this.shopLatitude = data.latitude;
                    }
                    if (data.longitude) {
                        this.shopLongitude = data.longitude;
                    }
                });
            },
        };
    });
});
